export default "__VITE_ASSET__BzKMJ_Jv__"